<template>
  <v-container class="pa-0 mx-0" style="min-width: 100%">
    <v-row class="primary-bg align-center" style="height: 150px;">
      <v-col class="mt-4 ml-4">
        <v-btn prepend-icon="mdi-arrow-left" to="/">{{ lang.impressum.back_to_home_link }}</v-btn>
      </v-col>
    </v-row>

    <v-row class="mx-4 my-12 justify-center">
      <v-col cols="12" md="8">
        <h1 class="text-h4 mb-6">{{ lang.impressum.caption }}</h1>

        <p><strong>{{ lang.impressum.paragraph_information }}</strong></p>
        <p>
          {{ lang.impressum.company }}<br>
          {{ lang.impressum.address }}<br>
          {{ lang.impressum.location }}<br>
          {{ lang.impressum.country }}
        </p>

        <br>

        <p><strong>{{ lang.impressum.represented_by_label }}:</strong><br>
          <span v-html="lang.impressum.represented_by_content"></span>
        </p>

        <br>

        <p><strong>{{ lang.impressum.register_entry }}</strong><br>
          {{ lang.impressum.entry_in_commercial_register }}<br>
          {{ lang.impressum.register_number_label }}: {{ lang.impressum.register_number_content }}
        </p>

        <br>

        <p><strong>{{ lang.impressum.contact }}:</strong><br>
          {{ lang.impressum.email_label }}: {{ lang.impressum.email_content }}
        </p>

        <br>

        <p style="display: none"><strong>{{ lang.impressum.register_entry }}:</strong><br>
          {{ lang.impressum.entry_in_commercial_register }}.<br>
          {{ lang.impressum.registry_court_label }}: {{ lang.impressum.registry_court_content }}<br>
          {{ lang.impressum.register_number_label }}: {{ lang.impressum.register_number_content }}
        </p>
        <p><strong>{{ lang.impressum.vat_id_label }}:</strong><br>
          {{ lang.impressum.vat_id_content }}
        </p>
        <p style="display: none"><strong>{{ lang.impressum.supervisory_authority_label }}:</strong><br>
          {{ lang.impressum.supervisory_authority_content }}
        </p>

        <h2 class="text-h5 mt-8 mb-4">{{ lang.impressum.liability_for_content_label }}</h2>
        <p v-html="lang.impressum.liability_for_content_content"></p>

        <h2 class="text-h5 mt-8 mb-4">{{ lang.impressum.liability_for_links_label }}</h2>
        <p v-html="lang.impressum.liability_for_links_content"></p>

        <h2 class="text-h5 mt-8 mb-4">{{ lang.impressum.copyright_label }}</h2>
        <p v-html="lang.impressum.copyright_content"></p>
      </v-col>
    </v-row>

    <contactSection></contactSection>

  </v-container>
</template>

<script>
import lang from "@/lang/lang";
import contactSection from "@/components/contactSection.vue";
import { useHead } from '@vueuse/head'

export default {
  setup() {
    useHead({
      title: 'Impressum – DM Energieberatung',
      link: [
        { rel: 'canonical', href: 'https://www.dm-energieberatung.de/impressum' }
      ]
    })
  },
  components: {
    contactSection,
  },
  data() {
    return {
      lang: lang
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>